/* sb-dc-flagshape-offset.js - 안전선(노란 점선)을 진짜 평행 오프셋으로 다시 그린다.
   2026-09-10.

   보고
   ----
   «아트보드의 티어드롭 외곽선을 보니 실선과 점선이 서로 평행하지 않다. 티어드롭이
   원래 이런 형태로 제작되는 건지, 디자인센터에서 고쳐야 하는 문제인지?»

   실선(재단선)은 B2Sign 템플릿 PDF 에서 뽑은 벡터라 정확하다. 문제는 점선 쪽이었다:
   sb-dc-flagshape.js 는 같은 path 를 가로·세로 각각 중심 쪽으로 «축소» 해서 그렸다
   (fx = (W-4)/W, fy = (H-4)/H). 직사각형에 가까울수록 비슷하지만, 티어드롭처럼
   곡률이 자리마다 다른 모양에서는 간격이 일정해지지 않는다. 비율도 가로세로가
   달라(비등방 축소) 모양 자체가 살짝 달라진다.

   하는 일
   -------
   같은 외곽선을 300점으로 썻어(getPointAtLength — 베지에 관계없이 정확),
   각 점을 **안쪽 법선 방향으로 2인치** 밀어 붙인다. 인치로 계산하므로 가로세로
   간격이 같다 = 진짜 평행선.
   마지막으로 끝이 댲쪽한 곳(티어드롭 꼭지점)에서 서로 교차해 뒤집힌 점은 버린다:
   원본 선에서 1.6인치보다 가까워졌거나 모양 밖으로 나간 점들이다. 그 자리는
   점선이 끊기는데, 억지로 이어 붙이면 사실이 아닌 안전선을 그리게 된다.

   원본 파일은 안 건드렸다 — sb-dc-flagshape.js 가 그린 #sbdc-flagshape 오버레이를
   보고 있다가, 그 안의 «축소로 만든 점선» 을 오프셋 경로로 갈아끼운다.
   오프셋 계산이 실패하면 원래 점선을 그대로 둔다.

   인쇄파일과 무관 — 화면 안내선일 뿐이다.
   진단: window.__dcFlagOffset() */
(function () {
  'use strict';

  var NS = 'http://www.w3.org/2000/svg';
  var SAFE_IN = 2;
  var N = 300;              /* 썻는 점 개수 */
  var DROP = 0.8;           /* 원본선과 2in x 0.8 보다 가까워지면 뒤집힌 것 */

  var info = { runs: 0, kept: 0, total: 0, key: '', why: '' };
  window.__dcFlagOffset = function () { return info; };

  var cache = {};

  function polyOf(d) {
    var svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('width', '0');
    svg.setAttribute('height', '0');
    svg.style.cssText = 'position:absolute;left:-9999px;top:0';
    var p = document.createElementNS(NS, 'path');
    p.setAttribute('d', d);
    svg.appendChild(p);
    document.body.appendChild(svg);
    var out = null;
    try {
      var L = p.getTotalLength();
      if (L > 0) {
        out = [];
        for (var i = 0; i < N; i++) {
          var q = p.getPointAtLength(L * i / N);
          out.push([q.x, q.y]);
        }
      }
    } catch (e) { out = null; }
    document.body.removeChild(svg);
    return out;
  }

  function areaOf(a) {
    var A = 0;
    for (var i = 0; i < a.length; i++) {
      var b = a[(i + 1) % a.length];
      A += a[i][0] * b[1] - b[0] * a[i][1];
    }
    return A / 2;
  }

  function inside(pt, poly) {
    var c = false;
    for (var i = 0, j = poly.length - 1; i < poly.length; j = i++) {
      var xi = poly[i][0], yi = poly[i][1], xj = poly[j][0], yj = poly[j][1];
      if (((yi > pt[1]) !== (yj > pt[1])) &&
          (pt[0] < (xj - xi) * (pt[1] - yi) / (yj - yi) + xi)) c = !c;
    }
    return c;
  }

  function dseg(P, A, B) {
    var vx = B[0] - A[0], vy = B[1] - A[1];
    var wx = P[0] - A[0], wy = P[1] - A[1];
    var c2 = vx * vx + vy * vy || 1;
    var t = (wx * vx + wy * vy) / c2;
    t = t < 0 ? 0 : (t > 1 ? 1 : t);
    return Math.hypot(P[0] - (A[0] + t * vx), P[1] - (A[1] + t * vy));
  }

  /* 0..1 외곽선 + 판 크기(인치) → 0..1 오프셋 패스 */
  function offsetPath(d, Win, Hin) {
    var pts0 = polyOf(d);
    if (!pts0) { info.why = 'no path sampling'; return ''; }

    var pts = pts0.map(function (q) { return [q[0] * Win, q[1] * Hin]; });
    var sign = areaOf(pts) > 0 ? 1 : -1;

    var off = [];
    for (var i = 0; i < N; i++) {
      var a = pts[(i - 1 + N) % N], b = pts[(i + 1) % N];
      var tx = b[0] - a[0], ty = b[1] - a[1];
      var m = Math.hypot(tx, ty) || 1;
      tx /= m; ty /= m;
      off.push([pts[i][0] - ty * sign * SAFE_IN, pts[i][1] + tx * sign * SAFE_IN]);
    }

    /* 뒤집힌 점 버리기 */
    var ok = [], kept = 0;
    for (i = 0; i < N; i++) {
      var q = off[i], good = inside(q, pts);
      if (good) {
        var md = 1e9;
        for (var j = 0; j < N; j++) {
          var dd = dseg(q, pts[j], pts[(j + 1) % N]);
          if (dd < md) md = dd;
          if (md < SAFE_IN * DROP) { good = false; break; }
        }
      }
      ok.push(good);
      if (good) kept++;
    }
    info.kept = kept; info.total = N;
    if (kept < N * 0.4) { info.why = 'too few points survived'; return ''; }

    /* 연속된 덩어리리로 나누어 각각 열린 선으로 */
    var start = 0;
    while (start < N && ok[start]) start++;
    if (start === N) start = 0;                    /* 전부 살아있으면 닫힌 고리 */

    var runs = [], cur = null;
    for (var k = 0; k < N; k++) {
      var idx = (start + k) % N;
      if (ok[idx]) {
        if (!cur) { cur = []; runs.push(cur); }
        cur.push(off[idx]);
      } else cur = null;
    }
    info.runs = runs.length;

    var out = '';
    runs.forEach(function (run) {
      if (run.length < 2) return;
      run.forEach(function (q, n) {
        out += (n ? 'L' : 'M') + (q[0] / Win).toFixed(5) + ' ' + (q[1] / Hin).toFixed(5) + ' ';
      });
      if (runs.length === 1 && kept === N) out += 'Z ';
    });
    return out.trim();
  }

  /* flagshape 가 그려놓은 점선을 갈아끼운다 */
  function sweep() {
    var svg = document.getElementById('sbdc-flagshape');
    if (!svg) return;
    var key = svg.getAttribute('data-key') || '';
    if (!key) return;

    var g = svg.querySelector('g');
    if (!g) return;
    var paths = g.querySelectorAll('path');
    if (paths.length < 3) return;                  /* dim, cut, safe */
    var safe = paths[paths.length - 1];
    if (safe.getAttribute('data-sboffset') === key) return;

    var cut = paths[paths.length - 2];
    var d = cut.getAttribute('d');
    var a = window.__dcApi;
    if (!d || !a || !a.spec || !(a.spec.widthIn > 0) || !(a.spec.heightIn > 0)) return;

    var ck = d + '|' + a.spec.widthIn + 'x' + a.spec.heightIn;
    if (!(ck in cache)) cache[ck] = offsetPath(d, +a.spec.widthIn, +a.spec.heightIn);
    var nd = cache[ck];
    if (!nd) { safe.setAttribute('data-sboffset', key); return; }   /* 실패하면 원래 것 그대로 */

    safe.setAttribute('d', nd);
    safe.removeAttribute('transform');
    safe.setAttribute('data-sboffset', key);
    info.key = key;
    info.why = '';
  }

  var timer = setInterval(function () { try { sweep(); } catch (e) { info.why = 'error: ' + (e && e.message); } }, 300);
  window.addEventListener('pagehide', function () { clearInterval(timer); });
})();
